import React from 'react';
import './FactionVentoryDescription.css';
import {CoinsStat} from "../../../PlayerStat/stats/CoinsStat";
import {
  FACTION_VENTORY_ADDITIONAL_GUILD_INCOME,
  FACTION_VENTORY_ADDITIONAL_TEMPLE_INCOME,
  FACTION_VENTORY_BUILDING_ROAD_COINS_DISCOUNT
} from "../../../../configs/factions/ventory";
import {WinPointsStat} from "../../../PlayerStat/stats/WinPointsStat";

const FactionVentoryDescription = () => {
  const road = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/road.1f281346.png'}
    alt={'Крепость'}
    title={'Крепость'}
  />;

  const discountElement = <img
    className={'policy-description-icon policy-description-icon-margin-right-left'}
    src={'/img/icons/percent white.png'}
    alt={'Скидка'}
    title={'Скидка'}
  />;

  const roadDiscount = <CoinsStat
    text={FACTION_VENTORY_BUILDING_ROAD_COINS_DISCOUNT}
    noShrinkOnMobile={true}
    isDarkColor={true}
    className={'policy-description-icon-margin-left-end'}
  />;

  const guild = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/special buildings/guild.ee26d2b8.png'}
    alt={'Гильдия'}
    title={'Гильдия'}
  />;

  const guildIncome = <CoinsStat
    text={`+${FACTION_VENTORY_ADDITIONAL_GUILD_INCOME}`}
    noShrinkOnMobile={true}
    isDarkColor={true}
  />;

  const temple = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/special buildings/temple.17c08b3d.png'}
    alt={'Храм'}
    title={'Храм'}
  />;

  const templeIncome = <WinPointsStat
    text={`+${FACTION_VENTORY_ADDITIONAL_TEMPLE_INCOME}`}
    noShrinkOnMobile={true}
    isDarkColor={true}
  />;

  return (
    <>
      <div className="policy-description_line">
        {road} дешевле {discountElement} на {roadDiscount}.
      </div>
      <div className="policy-description_line policy-description_line-margin-top-paragraph-large">
        <span className={'text-coins policy-description-icon-margin-left'}>
          Доход
        </span>
        {guild}{guildIncome}.
      </div>
      <div className="policy-description_line policy-description_line-margin-top-paragraph">
        <span className={'text-win-points-dark policy-description-icon-margin-left'}>
          Доход
        </span>
        {temple}{templeIncome}.
      </div>
    </>
  );
};

export default FactionVentoryDescription;
